import { getSandboxFrameSrc, getIframeHeightFromMessage, openLinkFromMessage, BUFFER_IFRAME_HEIGHT, SANDBOX_ATTRIBUTES } from '../markdown/render_sandboxed_mermaid';
export default {
    name: 'SandboxedMermaid',
    props: {
        source: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            iframeHeight: BUFFER_IFRAME_HEIGHT
        };
    },
    watch: {
        source () {
            this.updateDiagram();
        }
    },
    mounted () {
        window.addEventListener('message', this.onPostMessage, false);
    },
    destroyed () {
        window.removeEventListener('message', this.onPostMessage);
    },
    methods: {
        onPostMessage (event) {
            const container = this.$refs.diagramContainer;
            if (event.origin !== 'null' || event.source !== container?.contentWindow) {
                return;
            }
            if (openLinkFromMessage(event.data)) {
                return;
            }
            const height = getIframeHeightFromMessage(event.data);
            if (height === null) {
                return;
            }
            this.iframeHeight = height;
        },
        updateDiagram () {
            const container = this.$refs.diagramContainer;
            // Potential risk associated with '*' discussed in below thread
            // https://gitlab.com/gitlab-org/gitlab/-/merge_requests/74414#note_735183398
            container.contentWindow?.postMessage({
                source: this.source,
                proxiedUrls: null
            }, '*');
            container.addEventListener('load', ()=>{
                container.contentWindow?.postMessage({
                    source: this.source,
                    proxiedUrls: null
                }, '*');
            });
        }
    },
    sandboxFrameSrc: getSandboxFrameSrc(),
    sandboxAttributes: SANDBOX_ATTRIBUTES
};
